import { AppLayoutPortal } from '@jotta/ui/AppLayoutPortal'
import { observer } from 'mobx-react-lite'
import type { FileUploadManager } from '../ActionManager/FileUploadManager'
import { FileActionQueueStatus } from '../FileActionQueue/FileActionQueueStatus'

// TODO: PRobably need separate store from public-files
export const FileUploadStatus = observer<{ manager: FileUploadManager }>(
  function FileUploadStatus({ manager }) {
    return (
      <AppLayoutPortal slot="bottomStatusBar">
        {manager.open && <FileActionQueueStatus manager={manager} />}
      </AppLayoutPortal>
    )
  },
)
